/**
 * KeypadInputComponent displays the current inputValue of the keypad
 */

import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { KeypadConfigType } from '../../../interfaces/key-pad-config.enum';

import { E2E_ATTRIBUTES } from '@shared/types/enums/e2e-attributes.enum';

@Component({
  selector: 'keypad-input',
  styleUrls: ['keypad-input.component.scss'],
  templateUrl: './keypad-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class KeypadInputComponent {
  @Input() public placeholder = '';
  @Input() public mask = '';
  @Input() public kpType: KeypadConfigType;
  @Input() public isDefaultMinValue = false;
  @Input() public measure = '';
  @Input() public className: string | string[];

  @Output() public change: EventEmitter<string> = new EventEmitter<string>();

  public E2E_ATTRIBUTES: typeof E2E_ATTRIBUTES = E2E_ATTRIBUTES;

  public get value() {
    return this.mask
      ? this.mask.repeat(this.valueToDisplay.length)
      : this.valueToDisplay;
  }

  @Input() public set value(value: string) {
    this.valueToDisplay = value;
    this.change.emit(this.valueToDisplay);
  }

  private valueToDisplay: string;

  public get isCurrentValueSet() {
    return !(this.valueToDisplay === '');
  }
}
